import { useState } from "react";
import { Star } from "lucide-react";

export const Stars = ({ value, size = "h-4 w-4", onPick, testId }) => {
  const [hover, setHover] = useState(0);
  const shown = hover || value || 0;
  return (
    <span data-testid={testId} className="inline-flex items-center gap-0.5" onMouseLeave={() => setHover(0)}>
      {[1, 2, 3, 4, 5].map((n) => {
        const icon = <Star className={`${size} transition-colors ${n <= Math.round(shown) ? "fill-amber-400 text-amber-400" : "text-slate-600"}`} />;
        return onPick ? <button type="button" key={n} data-testid={`${testId}-${n}`} aria-label={`${n} stars`} onMouseEnter={() => setHover(n)} onClick={() => onPick(n)}>{icon}</button> : <span key={n}>{icon}</span>;
      })}
    </span>
  );
};
